export const billing = {
aiUsageAudit: {
title: "Audit IA et automatisation de l'espace de travail",
loading: "Chargement du journal d'audit...",
empty: "Aucun événement d'audit pour le moment.",
intro: "Piste d'audit des points d'intégration IA et automatisation pour cet espace de travail. Affiche les 200 derniers événements avec, si disponibles, capacité, trace, usage et métadonnées de crédit.",
refresh: "Actualiser",
refreshing: "Actualisation...",
noAccount: "Aucun compte d'espace de travail trouvé pour ce profil.",
loadFailed: "Échec du chargement des événements d'audit.",
service: "Service :",
status: "Statut :",
filters: {
all: "Tous",
success: "Succès",
error: "Erreur",
ai: "IA",
automation: "Automatisation",
},
totalCredits: "Total des crédits IA (filtré) :",
totalShown: "Total affiché :",
creditUnitsLogged: "Unités de crédit enregistrées (IA + automatisation, événements affichés) :",
noEventsFiltered: "Aucun événement trouvé pour les filtres sélectionnés.",
memberTitle: "Utilisation de l'IA",
memberSubtitle: "Les crédits IA sont partagés par tous les membres de votre espace de travail.",
memberBody: "Le propriétaire de cet espace de travail examine l'utilisation de l'IA. Le solde de crédits partagé se trouve dans Facturation et utilisation.",
},
usage: {
addons: {
  title: "Options",
  subtitle: "Fonctions en plus de votre offre, facturées par équipement.",
  loadFailed: "Impossible de charger les options. Réessayez plus tard.",
  perAssetMonth: "{{price}} par équipement et par mois",
  included: "Inclus dans votre offre",
  statusTrialing: "Activée : essai gratuit jusqu’au {{date}}",
  statusActive_one: "Activée pour {{count}} équipement : {{total}} par mois",
  statusActive_many: "Activée pour {{count}} équipements : {{total}} par mois",
  statusActive_other: "Activée pour {{count}} équipements : {{total}} par mois",
  statusActiveNoPrice_one: "Activée pour {{count}} équipement",
  statusActiveNoPrice_many: "Activée pour {{count}} équipements",
  statusActiveNoPrice_other: "Activée pour {{count}} équipements",
  statusOff: "Désactivée",
  notOnPlan: "Pas dans votre offre. Changez d’offre pour l’ajouter (Offres indique lesquelles le permettent).",
  notAvailableInApp: "Achat impossible dans l’application",
  adminsOnly: "Les administrateurs de l’espace ajoutent ou désactivent les options.",
  coverTitle: "Ce qu’elle couvre",
  coverWhole: "Tout l’espace",
  coverSites: "Sites choisis",
  coverHint: "Un site choisi couvre aussi les sites qu’il contient.",
  noSites: "Aucun site pour l’instant : elle couvre tout l’espace.",
  liveTotal_one: "{{count}} équipement × {{price}} = {{total}} par mois",
  liveTotal_many: "{{count}} équipements × {{price}} = {{total}} par mois",
  liveTotal_other: "{{count}} équipements × {{price}} = {{total}} par mois",
  trialNote: "Gratuite pendant {{days}} jours, puis facturée avec votre offre. Désactivable à tout moment.",
  proRata: "Les changements s’appliquent aujourd’hui et sont facturés ou crédités au prorata sur votre prochaine facture.",
  startTrial: "Essai gratuit de {{days}} jours",
  startPaid: "Ajouter à mon offre",
  save: "Enregistrer la couverture",
  end: "Désactiver",
  keep: "Conserver",
  endConfirmTitle: "Désactiver {{name}} ?",
  endConfirmBody: "Elle s’arrête aujourd’hui et le temps payé non utilisé est crédité sur votre prochaine facture. Vos données ESG sont conservées et reviennent si vous la réactivez.",
  chooseSite: "Choisissez au moins un site, ou tout l’espace.",
  failed: "Impossible de modifier l’option. Réessayez.",
},
  assistantGate: {
    debitFailedMember: "L'assistant n'a pas pu utiliser de crédits pour cette demande. Réessayez dans un instant.",
    debitFailedAdmin: "L'assistant n'a pas pu utiliser de crédits pour cette demande. Réessayez, ou vérifiez Facturation et utilisation si cela se reproduit.",
    debitFailedTitle: "Les crédits n'ont pas pu être utilisés",
    disabledAdmin: "L'IA n'est pas incluse dans le forfait de cet espace de travail. Ouvrez Facturation et utilisation pour voir les forfaits qui l'incluent.",
    disabledMemberUnnamed: "L'IA n'est pas incluse dans le forfait de cet espace de travail. Parlez du forfait au propriétaire de l'espace de travail.",
    disabledMember: "L'IA n'est pas incluse dans le forfait de cet espace de travail. Parlez du forfait à {{owner}}.",
    disabledTitle: "L'assistant IA est désactivé",
  },
  assetGate: {
    seePlans: "Voir les forfaits",
    subscriptionRequired: "Votre espace de travail a utilisé les actifs gratuits de son forfait. Démarrez un abonnement pour ajouter d'autres actifs.",
    askOwner: "Demandez au propriétaire de l'espace de travail d'ajouter un forfait avant de pouvoir ajouter d'autres actifs.",
    askOwnerNamed: "Demandez au propriétaire de {{workspace}} d'ajouter un forfait avant de pouvoir ajouter d'autres actifs.",
    title: "Abonnement requis",
  },
  checkout: {
    unavailable: "L'achat n'est pas disponible pour le moment. Réessayez plus tard.",
    needsEmail: "Ajoutez une adresse e-mail à votre profil avant de démarrer le paiement.",
    contactSales: "Ce forfait est vendu par notre équipe. Contactez AssetWRX pour commencer.",
    notConfigured: "Ce forfait n'est pas encore disponible à l'achat. Contactez l'assistance.",
    generic: "Impossible de démarrer le paiement. Réessayez dans un instant, ou contactez l'assistance si le problème persiste.",
  },
  store: {
    planGone: "Ce forfait n'est plus proposé. Fermez et rouvrez cet écran.",
    unavailable: "Les achats via la boutique d'applications ne sont pas disponibles dans cette version de l'application.",
    purchaseFailed: "L'achat n'a pas abouti. Réessayez.",
    ownerOnly: "Seul le propriétaire de l'espace de travail peut gérer son abonnement via la boutique d'applications.",
  },
  workAi: {
    hostFallback: "l’espace de travail",
    settingTitle: "IA pour les personnes avec qui vous travaillez",
    settingSubtitle: "Les prestataires et demandeurs peuvent utiliser l’IA sur vos interventions, inspections et actifs, payée avec vos crédits.",
    settingLabel: "Crédits par mois et par personne",
    settingHelper: "Laissez vide pour l’allocation standard. 0 la désactive.",
    settingPlaceholder: "Standard",
    settingInvalid: "Saisissez un nombre entier ou laissez vide.",
    settingSave: "Enregistrer",
    settingSaved: "Enregistré",
    settingFailed: "Impossible d’enregistrer l’allocation",
    usedTitle: "L’IA offerte par {{host}} est épuisée pour ce mois",
    offTitle: "{{host}} n’inclut pas d’IA sur ses travaux",
    useOwnBody: "Vous pouvez utiliser vos propres crédits d’IA à la place.",
    notNow: "Pas maintenant",
    useOwn: "Utiliser mes crédits",
    refused: "L’IA offerte par {{host}} est épuisée pour ce mois.",
  },
  aiGate: {
    freePeriodEnded: "L'IA est en pause car la période gratuite est terminée et cet espace de travail est en lecture seule.",
    pastDue: "L'IA est en pause à cause d'un échec de paiement. Mettez à jour la facturation pour la réactiver.",
    canceled: "L'IA est désactivée car l'abonnement de cet espace de travail a été annulé.",
    notEnoughCredits_other: "Cette action nécessite {{count}} crédits IA et votre espace de travail n'en a pas assez.",
    notEnoughCredits_many: "Cette action nécessite {{count}} crédits IA et votre espace de travail n'en a pas assez.",
    notEnoughCredits_one: "Cette action nécessite {{count}} crédit IA et votre espace de travail n'en a pas assez.",
    readOnly: "L'IA est en pause car cet espace de travail est en lecture seule.",
    notInPlan: "L'IA n'est pas incluse dans le forfait de cet espace de travail.",
    checkFailed: "Impossible de vérifier vos crédits IA. Réessayez.",
  },
  creditCode: {
    refund: "Remboursement",
    adjustment: "Ajustement",
    included: "Crédits inclus",
    purchase: "Achat",
    topUp: "Recharge",
    aiCredits: "Crédits IA",
    aiUsage: "Utilisation IA",
  },
  packCredits_other: "{{count}} crédits",
  packCredits_many: "{{count}} crédits",
  packCredits_one: "{{count}} crédit",
  planLoadFailed: "Impossible de charger votre forfait.",
  ownerManagesUnnamed: "Le propriétaire de l'espace de travail gère le forfait et les crédits.",
  ownerManages: "{{owner}} gère le forfait et les crédits de cet espace de travail.",
  confirmationAwaitingBody: "Terminez le paiement dans la fenêtre de paiement, puis revenez ici. Touchez Actualiser si votre forfait et vos crédits ne sont pas à jour.",
  confirmationAwaitingTitle: "En attente de votre paiement",
  paymentStatusInactiveDetailMember: "Aucun abonnement actif. Le propriétaire de l'espace de travail peut en démarrer un.",
  paymentStatusPausedDetailMember: "L'abonnement est en pause. Le propriétaire de l'espace de travail peut le reprendre.",
  paymentStatusPastDueDetailMember: "Un paiement est en retard. Le propriétaire de l'espace de travail peut le régler dans Facturation et utilisation.",
  statusFreePeriodEndedMember: "La période gratuite est terminée et l'espace de travail est en lecture seule. Le propriétaire peut choisir un forfait ; rien n'a été supprimé.",
  statusFreeLimitReachedMember: "La limite gratuite est atteinte. Le propriétaire de l'espace de travail peut choisir un forfait pour ajouter des actifs.",
  statusFreeUntilMember: "Gratuit jusqu'au {{date}}. Le propriétaire de l'espace de travail choisit le forfait.",
  statusFreeFirstAsset_other: "Votre forfait inclut {{count}} actifs gratuits. La facturation commence quand vous en ajoutez d'autres.",
  statusFreeFirstAsset_many: "Votre forfait inclut {{count}} actifs gratuits. La facturation commence quand vous en ajoutez d'autres.",
  statusFreeFirstAsset_one: "Votre forfait inclut {{count}} actif gratuit. La facturation commence quand vous ajoutez le suivant.",
  creditsNeeded_other: "Cette action nécessite {{count}} crédits et vous en avez {{balance}}.",
  creditsNeeded_many: "Cette action nécessite {{count}} crédits et vous en avez {{balance}}.",
  creditsNeeded_one: "Cette action nécessite {{count}} crédit et vous en avez {{balance}}.",
  continueWithoutAi: "Continuer sans l'IA",
  outOfCreditsOk: "OK",
  outOfCreditsNeutral: "Votre espace de travail n'a plus de crédits IA. Vous pouvez continuer sans l'IA.",
  outOfCreditsMemberBodyUnnamed: "Vous pouvez continuer sans l'IA. Demandez au propriétaire de l'espace de travail d'ajouter des crédits.",
  outOfCreditsMemberBody: "Vous pouvez continuer sans l'IA. Demandez à {{owner}} d'ajouter des crédits.",
  outOfCreditsAdminBodyNoBuy: "Vous pouvez continuer sans l'IA.",
  outOfCreditsAdminBody: "Vous pouvez continuer sans l'IA, ou acheter un pack de crédits.",
title: "Facturation et utilisation",
intro: "Consultez l'état de l'abonnement, les crédits et les prochaines actions de facturation.",
summaryIntro: "Votre forfait, vos crédits et votre facturation.",
outOfCreditsTitle: "Les crédits IA sont épuisés",
outOfCreditsBody: "Les actions IA consomment des crédits. Achetez un pack de crédits pour continuer, ou attendez vos crédits mensuels inclus.",
outOfCreditsNotNow: "Pas maintenant",
trialCapTitle: "Au-delà de votre limite d'essai",
creditPackPickerTitle: "Choisissez un pack de crédits",
creditPackPickerSubtitle: "Les crédits n'expirent jamais.",
buyCreditsCta: "Acheter",
cancel: "Annuler",
kpiSectionTitle: "Aperçu de l'usage",
kpiSectionHint: "Ce qui vous est facturé et les crédits IA dont vous disposez.",
kpiAssetsTitle: "Actifs facturables",
kpiAssetsBody: "Actifs actifs facturés ce cycle.",
kpiMonthlyPlanTitle: "Crédits du forfait",
kpiMonthlyPlanBody: "Crédits inclus chaque mois.",
kpiMonthlyPlanBodyUnlimited: "Les crédits mensuels sont illimités.",
kpiPurchasedTitle: "Crédits achetés",
kpiPurchasedBody: "Crédits complémentaires encore disponibles.",
kpiRemainingTitle: "Crédits restants",
kpiRemainingBody: "Crédits inclus + achetés restants.",
kpiRemainingBodyUnlimited: "Les crédits sont illimités pour cet espace de travail.",
loading: "Chargement de la facturation...",
refresh: "Actualiser",
refreshing: "Actualisation...",
noAccount: "Aucun compte d'espace de travail trouvé pour ce profil.",
loadFailed: "Échec du chargement des données de facturation.",
billingDataMissing: "Les données de facturation n'ont pas pu être affichées. Essayez d'actualiser.",
errorTitle: "Les données de facturation sont indisponibles",
emptyTitle: "La facturation nécessite un espace de travail",
emptyBody: "La facturation appartient à un espace de travail. Passez à un espace de travail pour voir son forfait, ses crédits et sa devise de facturation.",
planTitle: "Abonnement",
unlimited: "Illimité",
subscriptionSummaryTitle: "Résumé de l'abonnement",
subscriptionSummarySubtitle: "Statut fourni par le service de paiement et échéance de renouvellement pour cet espace de travail.",
managedOnWeb: "Les modifications de forfait et de crédits ne sont pas disponibles dans cette application.",
statusFreeUntil: "Gratuit jusqu'au {{date}}. Choisissez un forfait pour que votre espace de travail continue de fonctionner ensuite.",
internalEditionName: "Developer (édition de test interne)",
statusInternalEdition: "Édition de test interne : toutes les fonctions sont actives et rien n'est facturé. Réglée uniquement dans l'Admin.",
statusGranted: "Votre forfait est offert, sans date de fin.",
statusGrantedUntil: "Votre forfait est offert jusqu'au {{date}}. Choisissez un forfait avant cette date pour que votre espace de travail continue de fonctionner.",
statusFreeFirstAsset: "Rien à payer pour l'instant. La facturation commence quand vous dépassez les actifs gratuits de votre forfait.",
statusFreeLimitReached: "Votre limite gratuite est atteinte. Choisissez un forfait pour ajouter d'autres actifs.",
statusFreePeriodEnded: "Votre période gratuite est terminée et votre espace de travail est en lecture seule. Choisissez un forfait pour continuer ; rien n'a été supprimé.",
statusActive: "Votre abonnement est actif.",
statusActiveRenews: "Votre abonnement est actif et se renouvelle le {{date}}.",
statusActiveEnds: "Votre abonnement est résilié et prend fin le {{date}}. Vous conservez votre forfait jusque-là.",
statusBilledByStore: "Votre abonnement est facturé via la boutique d'applications. Gérez-le là-bas.",
changePlanHint: "Passez à un autre forfait ; le changement est confirmé avant tout débit.",
cancelSubscription: "Résilier l'abonnement",
cancelSubscriptionHint: "Votre forfait reste actif jusqu'à la fin de la période payée ; rien de plus n'est facturé.",
resumeSubscription: "Reprendre l'abonnement",
resumeSubscriptionHint: "Conservez votre forfait ; il se renouvelle comme avant.",
cancelSubscriptionConfirmTitle: "Résilier votre abonnement ?",
cancelSubscriptionConfirmBody: "Vous conservez {{plan}} jusqu'au {{date}} ; rien de plus n'est facturé. Vous pouvez reprendre à tout moment avant cette date.",
cancelSubscriptionConfirmBodyNoDate: "Vous conservez {{plan}} jusqu'à la fin de la période en cours ; rien de plus n'est facturé. Vous pouvez reprendre à tout moment avant cette date.",
cancelSubscriptionKeep: "Garder mon forfait",
cancelSubscriptionConfirm: "Résilier l'abonnement",
cancelSubscriptionError: "Impossible de modifier votre abonnement.",
planReference: "Facturation {{plan}}",
paymentStatusLabel: "Statut de paiement",
paymentStatusFreeDetail: "Rien à payer pour l'instant. La facturation commence quand vous dépassez les actifs gratuits de votre forfait.",
paymentStatusGrantedDetail: "Offert. Rien n'est facturé.",
paymentStatusSubscriptionRequiredDetail: "Limite gratuite atteinte. Démarrez un abonnement pour continuer à ajouter des actifs actifs.",
paymentStatusStripeDetail: "La facturation est active pour cet espace de travail.",
paymentStatusPastDueDetail: "Le paiement est en retard. Réglez-le dans le portail de facturation pour éviter une interruption de service.",
paymentStatusPausedDetail: "L'abonnement est en pause. Reprenez la facturation avant d'ajouter d'autres actifs actifs.",
paymentStatusInactiveDetail: "Aucun prélèvement actif. Démarrez ou restaurez un abonnement pour poursuivre la facturation.",
paymentStatusInternalDetail: "La facturation de cet espace de travail n’est pas encore entièrement configurée ; voici le dernier statut connu.",
renewalDateLabel: "Date de renouvellement",
renewalKnownDetail: "Basé sur la dernière fin de période d'abonnement synchronisée.",
renewalUnknownDetail: "L'échéance de renouvellement n'est pas encore disponible pour cet espace de travail.",
lastTrueUpLabel: "Dernier comptage des actifs",
trueUpKnownDetail: "Date du dernier comptage de vos actifs actifs pour la facturation.",
trueUpUnknownDetail: "Vos actifs n'ont pas encore été comptés pour la facturation.",
presentmentCurrencyLabel: "Devise de facturation",
presentmentCurrencyBadge: "Facturation en {{currency}}",
currencyUnknown: "Inconnue",
currencyPresentmentNote: "Les prix sont fixés en {{currency}}. Votre facture peut afficher votre devise locale.",
currencyCatalogOnlyNote: "Les prix et les factures sont en {{currency}}.",
editionTitle: "Votre forfait",
editionSubtitle: "Votre forfait définit les fonctionnalités disponibles. Les actifs et les crédits IA sont facturés séparément.",
monthlyAmountTitle: "Montant mensuel estimé",
monthlyAmountSubtitle: "Votre facture indique le total définitif.",
amountFinal: "Montant final",
amountEstimated: "Montant estimé",
amountUnavailable: "Montant indisponible",
amountFinalExplanation: "D'après la dernière facture réglée.",
amountEstimatedPresentmentExplanation: "Une estimation. Votre facture indique le montant définitif, éventuellement dans votre devise locale.",
amountEstimatedCatalogExplanation: "Une estimation en {{currency}}. Votre facture indique le montant définitif.",
amountUnavailableExplanation: "Un montant fiable destiné au client n'est pas encore disponible.",
creditsAndAssetsTitle: "Crédits et actifs facturables",
creditsAndAssetsSubtitle: "Soldes opérationnels pour l'usage et les limites.",
billableAssetsMetric: "Actifs facturables actifs",
includedMonthlyMetric: "Crédits mensuels inclus",
purchasedCreditsMetric: "Crédits achetés",
totalRemainingCreditsMetric: "Total des crédits restants",
pricingExplanationTitle: "Détails tarifaires",
pricingExplanationSubtitle: "Tranches de facturation actuelles du catalogue.",
pricingSummaryKnown: "Tarification progressive pour {{assetCount}} actifs facturables actifs, référencée en {{currency}}.",
pricingSummaryUnknown: "Aucune tranche tarifaire structurée n'est encore disponible dans le catalogue de facturation, l'interface ne peut donc pas fournir d'explication tarifaire ligne par ligne fiable.",
pricingBandOpenEnded: "{{min}}+ actifs",
pricingBandRange: "{{min}} à {{max}} actifs",
pricingBandLabel: "{{label}}",
pricingBandUnknown: "Tarif indisponible",
pricingBandEmpty: "Aucune tranche tarifaire n'est configurée pour ce modèle de facturation pour le moment.",
catalogReferenceNote: "Devise de référence catalogue : {{currency}}.",
startSubscription: "Démarrer l'abonnement",
startSubscriptionHint: "Démarrez un abonnement pour ajouter plus d’actifs que ceux inclus gratuitement dans votre forfait.",
startSubscriptionAdminOnly: "Seul le propriétaire de l'espace de travail peut démarrer l'abonnement.",
startSubscriptionStripeOff: "L'achat n'est pas disponible pour le moment.",
startSubscriptionUnavailable: "Cet espace de travail ne peut pas démarrer un nouvel abonnement depuis son état de facturation actuel.",
manageSubscriptionHint: "Ouvrez le portail de facturation pour gérer votre abonnement ou votre moyen de paiement.",
manageBillingAdminOnly: "Seul le propriétaire de l'espace de travail peut gérer la facturation.",
manageBillingUnavailable: "L'accès au portail de facturation n'est pas encore disponible pour cet espace de travail.",
buyMoreCredits: "Acheter des crédits",
buyCreditsHint: "Achetez un pack de crédits. Paiement unique et sécurisé.",
buyCreditsAdminOnly: "Seul le propriétaire de l'espace de travail peut acheter des crédits.",
buyCreditsStripeOff: "L'achat n'est pas disponible pour le moment.",
buyCreditsUnavailable: "Aucun prix de pack de crédits n'est encore configuré.",
buyCreditsPriceHint: "Prix catalogue de référence : {{price}}.",
priceUnavailable: "Prix indisponible",
activityTitle: "Activité de crédit récente",
activitySubtitle: "Derniers mouvements de crédit (aperçu).",
subscriptionDetailsTitle: "Détails de l'abonnement",
subscriptionDetailsSubtitle: "Détails opérationnels de synchronisation et d'échéance.",
currencyDetailsTitle: "Détails de la devise",
currencyDetailsSubtitle: "Comportement des devises de présentation et de catalogue.",
showDetails: "Afficher les détails",
hideDetails: "Masquer les détails",
ledgerEmpty: "Aucune activité de crédits pour le moment.",
linkAudit: "Ouvrir l'audit IA et automatisation",
manageStripeBilling: "Gérer l'abonnement",
stripeCheckoutError: "Impossible d'ouvrir le paiement. Réessayez.",
stripePortalError: "Impossible d'ouvrir la gestion de la facturation. Réessayez.",
stripeConfigOff: "Le paiement Stripe est désactivé. Dans le fichier `.env` à la racine du projet, définissez EXPO_PUBLIC_STRIPE_BILLING_ENABLED=true, puis ajoutez EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION et/ou EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 (chacun doit être un identifiant Stripe price_...). Redémarrez Expo avec `npx expo start --clear`.",
stripeConfigNoPrices: "Stripe est activé mais aucun identifiant de prix valide n'a été trouvé. Utilisez des identifiants de prix Stripe commençant par `price_` (pas `prod_`). Définissez EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION et/ou EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 dans `.env`, puis redémarrez Expo.",
confirmationConfirmedTitle: "Achat terminé",
confirmationCancelledTitle: "Paiement annulé",
confirmationPendingTitle: "Finalisation de votre achat",
confirmationConfirmedBody: "C'est fait. Votre forfait et vos crédits ci-dessous sont à jour.",
confirmationCancelledBody: "Aucune modification de facturation n’a été appliquée. Votre forfait et vos crédits actuels sont inchangés.",
confirmationPendingBody: "Paiement reçu. Votre forfait et vos crédits se mettent à jour dans quelques secondes. Touchez Actualiser si ce n'est pas le cas.",
trialCapBody_one: "Votre essai autorise {{max}}. Vous avez {{billable}} actifs actifs, donc {{count}} actif commencera à être facturé quand votre essai deviendra un forfait payant.",
trialCapBody_other: "Votre essai autorise {{max}}. Vous avez {{billable}} actifs actifs, donc {{count}} actifs commenceront à être facturés quand votre essai deviendra un forfait payant.",
trialCapBodyDated_one: "Votre essai autorise {{max}}. Vous avez {{billable}} actifs actifs, donc {{count}} actif commencera à être facturé à la fin de votre essai le {{trialEnd}}.",
trialCapBodyDated_other: "Votre essai autorise {{max}}. Vous avez {{billable}} actifs actifs, donc {{count}} actifs commenceront à être facturés à la fin de votre essai le {{trialEnd}}.",
forecastTitle: "Consommation et prévision des crédits IA",
forecastSubtitle: "Comment vos crédits ont été utilisés ces 30 derniers jours, et combien de temps ils dureront.",
consumedLast30Days: "Consommé en 30 jours",
averageDailyUse: "Moyenne par jour",
estimatedRunway: "Les crédits durent environ",
runwayNotLimited: "Sans limite",
runwayDays_one: "{{count}} jour",
runwayDays_other: "{{count}} jours",
ledgerReconciled: "Le solde est à jour",
ledgerPartial: "Le solde est en cours de mise à jour",
contactAdminTitle: "La facturation est gérée par le propriétaire de l'espace de travail",
contactAdminTitleNamed: "L’offre et les crédits sont gérés par le propriétaire de {{workspace}}",
contactAdminSubtitle: "Vous pouvez consulter l'utilisation ici. Seul le propriétaire peut changer le forfait ou acheter des crédits.",
viewWorkspaceAdmins: "Voir les administrateurs de l’espace de travail",
detailsTitle: "Détails de facturation",
detailsSubtitle: "Abonnement, tarifs et devise.",
chargingPolicyTitle: "Comment les crédits IA sont facturés",
chargingPolicySubtitle: "Ce que vous payez, ce que vous ne payez pas, et ce qui se passe en cas d'échec.",
chargingSuccess: "Vous êtes facturé une seule fois pour l'IA qui fonctionne, après avoir reçu le résultat.",
chargingFailure: "Un résultat IA échoué n’est pas facturé, et le travail manuel reste disponible.",
chargingRetry: "Si l'enregistrement du débit échoue, nous réessayons une fois et ne facturons jamais deux fois.",
packForecastNoPattern: "L’impact prévisionnel apparaît une fois la consommation enregistrée.",
packForecastDays_one: "Environ {{count}} jour supplémentaire au rythme actuel",
packForecastDays_other: "Environ {{count}} jours supplémentaires au rythme actuel",
trialCapBody_many: "Votre essai autorise {{max}}. Vous avez {{billable}} actifs actifs, donc {{count}} actifs commenceront à être facturés quand votre essai deviendra un forfait payant.",
trialCapBodyDated_many: "Votre essai autorise {{max}}. Vous avez {{billable}} actifs actifs, donc {{count}} actifs commenceront à être facturés à la fin de votre essai le {{trialEnd}}.",
runwayDays_many: "{{count}} jours",
packForecastDays_many: "Environ {{count}} jours supplémentaires au rythme actuel",
},
};
